<template>
    <div>
        <b-overlay :show="!dataLoaded">
            <b-card title="Sales">
                <b-row>
                    <b-col sm="4">
                        <label>Date from</label>
                        <b-form-datepicker v-model="dateFrom" @input="loadData"/>
                    </b-col>
                    <b-col sm="4">
                        <label>Date to</label>
                        <b-form-datepicker v-model="dateTo" @input="loadData"/>
                    </b-col>
                </b-row>


                <SalesTable :sales="sales" @update-data="updateData"/>
            </b-card>
        </b-overlay>
    </div>
</template>
<script>

    import {BCard, BOverlay, BRow, BCol, BFormDatepicker} from 'bootstrap-vue'
    import SalesTable from '@/views/components/SalesTable'

    export default {
        components: {
            BCard,
            BOverlay,
            BRow,
            BCol,
            BFormDatepicker,
            SalesTable
        },
        data() {
            return {
                dataLoaded: false,
                sales: [],
                dateFrom: '',
                dateTo: ''
            }
        },
        props: {
            userId: {
                type: String,
                required:true
            }
        },
        methods: {
            loadData() {
                this.dataLoaded = false
                const thisIns = this
                const dateFrom = this.moment(this.dateFrom).startOf('day').utc().format()
                const dateTo = this.moment(this.dateTo).endOf('day').utc().format()
                const loadPromise = this.$http.get(`/api/management/v1/user/${this.userId}/sales?&time.gte=${dateFrom}&&time.lte=${dateTo}`)
                loadPromise.then(function(response) {
                    thisIns.sales = response.data
                }).catch(function(error) {
                    thisIns.$printError((error.response) ? error.response.data : error)
                })

                Promise.all([loadPromise]).finally(function() {
                    thisIns.dataLoaded = true
                })
            },
            setDate() {
                this.dateFrom = this.moment().startOf('month').utc(+1).format()
                this.dateTo = this.moment().endOf('month').utc(+1).format()
            },
            updateData() {
                this.loadData()
            }
        },
        async mounted() {
            await this.setDate()
            await this.loadData()
        }
    }
</script>